var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseKeywordChip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25597 0.73967C8.85959 0.343288 8.21693 0.343287 7.82055 0.739669L4.97316 3.58705L2.1552 0.769086C1.75882 0.372704 1.11615 0.372705 0.719772 0.769087C0.32339 1.16547 0.32339 1.80813 0.719772 2.20451L3.53774 5.02248L0.770691 7.78952C0.374309 8.18591 0.37431 8.82857 0.770692 9.22495C1.16707 9.62133 1.80974 9.62133 2.20612 9.22495L4.97316 6.4579L7.76963 9.25437C8.16601 9.65075 8.80867 9.65075 9.20505 9.25437C9.60144 8.85799 9.60144 8.21532 9.20505 7.81894L6.40859 5.02248L9.25597 2.1751C9.65236 1.77871 9.65236 1.13605 9.25597 0.73967Z",
    fill: "#9CA2AB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseKeywordChip);
export default __webpack_public_path__ + "static/media/close-keyword-chip.454cae80805c6b4c099c9c227b10ef6a.svg";
export { ForwardRef as ReactComponent };